import { customElement } from "lit/decorators.js";
import { MenuItem } from "@/components/menu-item";

@customElement("eko-dropdown-item")
export class DropdownItem extends MenuItem {
  constructor() {
    super();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-dropdown-item": DropdownItem;
  }
}

export default DropdownItem;
